import React, { useEffect, useState } from 'react';

// Вариант 1: Крутящиеся точки
export const LoadingDots = ({ size = 60, color = '#ffffff' }) => (
  <svg width={size} height={size} viewBox="0 0 60 60">
    <circle cx="30" cy="15" r="4" fill={color}>
      <animate
        attributeName="opacity"
        values="1;0.3;1"
        dur="1s"
        repeatCount="indefinite"
        begin="0s"
      />
    </circle>
    <circle cx="45" cy="30" r="4" fill={color}>
      <animate
        attributeName="opacity"
        values="1;0.3;1"
        dur="1s"
        repeatCount="indefinite"
        begin="0.33s"
      />
    </circle>
    <circle cx="30" cy="45" r="4" fill={color}>
      <animate
        attributeName="opacity"
        values="1;0.3;1"
        dur="1s"
        repeatCount="indefinite"
        begin="0.66s"
      />
    </circle>
    <circle cx="15" cy="30" r="4" fill={color}>
      <animate
        attributeName="opacity"
        values="1;0.3;1"
        dur="1s"
        repeatCount="indefinite"
        begin="0.99s"
      />
    </circle>
  </svg>
);

// Вариант 2: Спиннер
export const LoadingSpinner = ({ size = 60, color = '#ffffff' }) => (
  <svg width={size} height={size} viewBox="0 0 60 60">
    <circle
      cx="30"
      cy="30"
      r="20"
      fill="none"
      stroke={color}
      strokeWidth="6"
      strokeLinecap="round"
      strokeDasharray="31.416"
      strokeDashoffset="31.416"
    >
      <animate
        attributeName="stroke-dasharray"
        dur="2s"
        values="0 31.416;15.708 15.708;0 31.416"
        repeatCount="indefinite"
      />
      <animate
        attributeName="stroke-dashoffset"
        dur="2s"
        values="0;-15.708;-31.416"
        repeatCount="indefinite"
      />
    </circle>
  </svg>
);

// Вариант 3: Пульсирующие кольца
export const LoadingRings = ({ size = 60, color = '#ffffff' }) => (
  <svg width={size} height={size} viewBox="0 0 60 60">
    <circle
      cx="30"
      cy="30"
      r="10"
      fill="none"
      stroke={color}
      strokeWidth="2"
      opacity="0.8"
    >
      <animate
        attributeName="r"
        values="10;20;10"
        dur="2s"
        repeatCount="indefinite"
      />
      <animate
        attributeName="opacity"
        values="0.8;0.2;0.8"
        dur="2s"
        repeatCount="indefinite"
      />
    </circle>
    <circle
      cx="30"
      cy="30"
      r="15"
      fill="none"
      stroke={color}
      strokeWidth="2"
      opacity="0.6"
    >
      <animate
        attributeName="r"
        values="15;25;15"
        dur="2s"
        repeatCount="indefinite"
        begin="0.5s"
      />
      <animate
        attributeName="opacity"
        values="0.6;0.1;0.6"
        dur="2s"
        repeatCount="indefinite"
        begin="0.5s"
      />
    </circle>
  </svg>
);

// Вариант 4: Модный геометрический
export const LoadingGeometric = ({ size = 60, color = '#ffffff' }) => (
  <svg width={size} height={size} viewBox="0 0 60 60">
    <g>
      <animateTransform
        attributeName="transform"
        type="rotate"
        values="0 30 30;360 30 30"
        dur="2s"
        repeatCount="indefinite"
      />
      <rect x="25" y="10" width="10" height="10" fill={color} opacity="0.9">
        <animate
          attributeName="opacity"
          values="0.9;0.3;0.9"
          dur="1s"
          repeatCount="indefinite"
          begin="0s"
        />
      </rect>
      <rect x="40" y="25" width="10" height="10" fill={color} opacity="0.7">
        <animate
          attributeName="opacity"
          values="0.7;0.3;0.7"
          dur="1s"
          repeatCount="indefinite"
          begin="0.25s"
        />
      </rect>
      <rect x="25" y="40" width="10" height="10" fill={color} opacity="0.5">
        <animate
          attributeName="opacity"
          values="0.5;0.3;0.5"
          dur="1s"
          repeatCount="indefinite"
          begin="0.5s"
        />
      </rect>
      <rect x="10" y="25" width="10" height="10" fill={color} opacity="0.3">
        <animate
          attributeName="opacity"
          values="0.3;0.1;0.3"
          dur="1s"
          repeatCount="indefinite"
          begin="0.75s"
        />
      </rect>
    </g>
  </svg>
);

// Вариант 5: Волны
export const LoadingWaves = ({ size = 60, color = '#ffffff' }) => (
  <svg width={size} height={size} viewBox="0 0 60 60">
    <rect x="10" y="20" width="4" height="20" fill={color}>
      <animate
        attributeName="height"
        values="20;40;20"
        dur="1s"
        repeatCount="indefinite"
        begin="0s"
      />
      <animate
        attributeName="y"
        values="20;10;20"
        dur="1s"
        repeatCount="indefinite"
        begin="0s"
      />
    </rect>
    <rect x="18" y="20" width="4" height="20" fill={color}>
      <animate
        attributeName="height"
        values="20;40;20"
        dur="1s"
        repeatCount="indefinite"
        begin="0.1s"
      />
      <animate
        attributeName="y"
        values="20;10;20"
        dur="1s"
        repeatCount="indefinite"
        begin="0.1s"
      />
    </rect>
    <rect x="26" y="20" width="4" height="20" fill={color}>
      <animate
        attributeName="height"
        values="20;40;20"
        dur="1s"
        repeatCount="indefinite"
        begin="0.2s"
      />
      <animate
        attributeName="y"
        values="20;10;20"
        dur="1s"
        repeatCount="indefinite"
        begin="0.2s"
      />
    </rect>
    <rect x="34" y="20" width="4" height="20" fill={color}>
      <animate
        attributeName="height"
        values="20;40;20"
        dur="1s"
        repeatCount="indefinite"
        begin="0.3s"
      />
      <animate
        attributeName="y"
        values="20;10;20"
        dur="1s"
        repeatCount="indefinite"
        begin="0.3s"
      />
    </rect>
    <rect x="42" y="20" width="4" height="20" fill={color}>
      <animate
        attributeName="height"
        values="20;40;20"
        dur="1s"
        repeatCount="indefinite"
        begin="0.4s"
      />
      <animate
        attributeName="y"
        values="20;10;20"
        dur="1s"
        repeatCount="indefinite"
        begin="0.4s"
      />
    </rect>
  </svg>
);

// Обновленный компонент загрузки
export const AnimatedLogoFallback = () => {
  const [showButton, setShowButton] = useState(false);
  const [countdown, setCountdown] = useState(10);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          setShowButton(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <div className="fixed z-[500] inset-0 flex items-center justify-center bg-black">
      <div className="flex flex-col items-center gap-4">
        {/* Выберите один из вариантов */}
        <LoadingSpinner size={80} color="#ffffff" />
        {/* <LoadingDots size={80} color="#ffffff" /> */}
        {/* <LoadingRings size={80} color="#ffffff" /> */}
        {/* <LoadingGeometric size={80} color="#ffffff" /> */}
        {/* <LoadingWaves size={80} color="#ffffff" /> */}

        {/* Кнопка копирования URL */}
        {showButton && (
          <button
            onClick={handleCopy}
            className="mt-8 px-6 py-3 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white rounded-lg transition-all duration-200 border border-white/20 hover:border-white/40"
          >
            {copied ? '✓ Скопировано!' : '📋 Скопировать URL'}
          </button>
        )}
      </div>
    </div>
  );
};
